module.exports = __webpack_public_path__ + "media/images/flags/16/Mongolia-1c5421b06b0dbf8977e8b5d8b528a5c2.png";